angular.module('qbePortal').controller('CybersourceCallbackController', [
	'$scope',
	'$stateParams',
	'dynamicRouter',
	'Util',
	'paymentLoggerService',
	function($scope, $stateParams, dynamicRouter, Util, paymentLoggerService) {
		var $ctrl = this;
		$scope.$root.$broadcast('loading-animation-end');

		var success =
			$stateParams.status === 'SUCCESS' ||
			$stateParams.status === 'AWAITING_PROCESS';

		paymentLoggerService.trackQuoteStatus(
			'processing Cybersource callback',
			'show done page or error page',
			null
		);

		console.log(
			'window.parent.$controllerScope',
			window.parent.$controllerScope
		);
		// Access parent window to call the callback function
		if (window.parent && window.parent.$controllerScope) {
			parent.$controllerScope.onPaymentCallback(success, $stateParams);
		}
	}
]);
